import DocumentUploadNew from '@/app/common/components/Documents/DocumentUploadNew'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { AppRoutePaths } from '@/routing/route_paths'
import { useTranslation } from 'react-i18next'
import useStudenDetailsDocumentParams from './hooks/useStudentDetailsDocumentParams'
import { useWizardContext } from './StudentDetailsWizardProvider'

export const DocumentCapturePage = () => {
  const { t: translate } = useTranslation()
  const { info, onRouteChange } = useStudenDetailsDocumentParams()
  const {updateFormData} = useWizardContext()
  const selectedForm = info()
  const { student_details } = AppRoutePaths.family_application


  const isRelationship = window.location.pathname.includes('relationship')

  const pathName = !isRelationship
    ? student_details.special_education.document_review
    : student_details.relationship.document_review

  const getTitle = (): string => {
    if (selectedForm.longName == 'special_education')
      return translate('proof_special_education')

    return `${translate('upload')} ${translate(selectedForm?.longName ?? selectedForm.name)}`
  }



  const handleFileChange = (file: File): void => {
      updateFormData("DateOfBirthFile", file)
      onRouteChange(pathName)

  }

    return (
      <FamilyWizardLayout>
        <FamilyWizardLayout.Header>
          <h1>{getTitle()}</h1>
        </FamilyWizardLayout.Header>
        <FamilyWizardLayout.Content className="w-full items-center justify-center">
          <DocumentUploadNew
            onUpload={(files) => {
              handleFileChange(files[0])
            }}
          />
        </FamilyWizardLayout.Content>
      </FamilyWizardLayout>
    )
  }
